var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDinersClub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 291.764 291.764",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M122.4 190.613c37.122.177 71.004-30.274 71.004-67.32 0-40.511-33.882-68.513-71.003-68.5H90.454c-37.566-.013-68.487 27.997-68.487 68.5 0 37.054 30.92 67.498 68.487 67.32H122.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#a1a1aa",
    d: "M90.605 60.407c-34.327.01-62.143 27.835-62.151 62.175.008 34.335 27.824 62.156 62.15 62.167 34.336-.011 62.157-27.832 62.162-62.167-.005-34.34-27.826-62.165-62.161-62.175zm-39.396 62.175c.032-16.78 10.513-31.09 25.291-36.777v73.545c-14.778-5.683-25.259-19.985-25.29-36.768zm53.495 36.784V85.803c14.784 5.673 25.28 19.99 25.307 36.78-.027 16.793-10.523 31.1-25.307 36.783z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0079BE",
    d: "M122.4 190.613c37.122.177 71.004-30.274 71.004-67.32 0-40.511-33.882-68.513-71.003-68.5H90.454c-37.566-.013-68.487 27.997-68.487 68.5 0 37.054 30.92 67.498 68.487 67.32H122.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M90.605 60.407c-34.327.01-62.143 27.835-62.151 62.175.008 34.335 27.824 62.156 62.15 62.167 34.336-.011 62.157-27.832 62.162-62.167-.005-34.34-27.826-62.165-62.161-62.175zm-39.396 62.175c.032-16.78 10.513-31.09 25.291-36.777v73.545c-14.778-5.683-25.259-19.985-25.29-36.768zm53.495 36.784V85.803c14.784 5.673 25.28 19.99 25.307 36.78-.027 16.793-10.523 31.1-25.307 36.783z"
  })));
}

var MemoSvgDinersClub = /*#__PURE__*/React.memo(SvgDinersClub);
export default MemoSvgDinersClub;